/* Collection filters apply when the drawer is dismissed or Show results is chosen. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.shFiltersReady) return;
    root.dataset.shFiltersReady = 'true';
    var info = root.querySelector('[data-sh-page-info]');
    var grid = root.querySelector('[data-sh-grid]');
    if (!info || !grid) return;
    // card-product emits its shared CSS in the first product card. Keep those
    // assets when filtering replaces that card (or loads a later page first).
    grid.querySelectorAll('style, link[rel="stylesheet"]').forEach(function (asset) {
      if (asset.tagName === 'LINK' && Array.from(document.head.querySelectorAll('link[rel="stylesheet"]')).some(function (link) { return link.href === asset.href; })) {
        asset.remove();
      } else {
        document.head.appendChild(asset);
      }
    });
    var form = root.querySelector('[data-sh-form]');
    var sortSelect = root.querySelector('[data-sh-sort]');
    var refine = root.querySelector('[data-sh-refine]');
    var dialog = root.querySelector('[data-sh-dialog]');
    var summary = refine.querySelector('summary');
    var filterStatus = root.querySelector('[data-sh-filter-status]');
    var status = root.querySelector('[data-sh-status]');
    var empty = root.querySelector('[data-sh-empty]');
    var pagination = root.querySelector('[data-sh-pagination]');
    var submit = form.querySelector('[type="submit"]');
    var choices = Array.from(form.querySelectorAll('[data-sh-choice]'));
    var fields = Array.from(form.querySelectorAll('input[name]'));
    var names = Array.from(new Set(fields.map(function (field) { return field.name; })));
    var categories = choices.filter(function (choice) { return choice.name === 'sh_category' && choice.value; }).map(function (choice) { return choice.value; });
    var comingSoonCategories = choices.filter(function (choice) { return choice.name === 'sh_category' && choice.hasAttribute('data-sh-coming-soon'); }).map(function (choice) { return choice.value; });
    var womensCategories = ['knits', 'jackets', 'hoodies', 'sweatshirts', 'fleeces', 'trousers', 'tops', 'swimwear', 'accessories'];
    var womensSizePairs = [['XXS', '4'], ['XS', '6'], ['S', '8'], ['M', '10'], ['L', '12'], ['XL', '14']];
    var seasonParam = 'filter.p.m.custom.season';
    var sectionId = info.dataset.sectionId;
    var pageSize = Number(info.dataset.pageSize) || (root.dataset.shCollection === 'all' ? 48 : 24);
    var cache = new Map();
    var optionCache = new Map();
    var optionRevision = 0;
    var optionsPending = false;
    var closePending = false;
    var sizeParam = 'filter.v.option.size';
    var pairParam = 'sh_size_pair';
    var sizeFamilyByValue = new Map(choices.filter(function (choice) { return choice.name === sizeParam; }).map(function (choice) {
      return [choice.value, Number(choice.dataset.label) >= 20 ? 'waist' : 'clothing'];
    }));
    var omittedSizeData = form.querySelector('[data-sh-omitted-sizes]');
    var omittedSizes = omittedSizeData ? JSON.parse(omittedSizeData.textContent) : [];
    var pairedSizes = [];
    var categoryGroups = { tops: ['tees', 'camis', 'longsleeves', 'tops'], swimwear: ['boardies', 'swimwear'] };
    var revision = 0;
    var activeUrl = cleanUrl(location.href);
    var categoryCarousel = root.querySelector('[data-sh-category-carousel]');
    var categoryTrack = categoryCarousel && categoryCarousel.querySelector('[data-sh-category-track]');
    var categoryTiles = categoryCarousel ? Array.from(categoryCarousel.querySelectorAll('[data-sh-category-tile]')) : [];
    var carouselOrder = null;
    var state = null;
    var busy = false;
    var lockedY = null;
    var previousBodyTop = '';
    var previousScrollbar = '';
    var restoring = false;
    var restoreRevision = 0;
    var saveTimer;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    // Browsers can retain :focus-visible when a previously focused summary is tapped.
    // Track interaction within this control so pointer use clears the ring, while
    // Tab and other keyboard navigation keep their visible focus indicator.
    info.addEventListener('pointerdown', function () { info.dataset.shInput = 'pointer'; }, { passive: true });
    document.addEventListener('keydown', function (event) {
      if (root.isConnected && (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ' || event.key.indexOf('Arrow') === 0)) info.dataset.shInput = 'keyboard';
    });

    function savedBrowse() {
      var saved = history.state && history.state.shBrowse;
      if (!saved || saved.version !== 1 || saved.section !== sectionId || saved.kind !== root.dataset.shCollection) return null;
      if (saved.key !== selectionKey(cleanUrl(location.href))) return null;
      if (!Number.isFinite(saved.y) || !Number.isInteger(saved.shown) || saved.shown < 0) return null;
      return saved;
    }
    function saveBrowse() {
      clearTimeout(saveTimer);
      if (!state || restoring || !root.isConnected || selectionKey(activeUrl) !== selectionKey(cleanUrl(location.href))) return;
      var y = lockedY === null ? window.scrollY : lockedY;
      var cards = Array.from(grid.children);
      var index = cards.findIndex(function (card) { return card.getBoundingClientRect().bottom > 0; });
      var card = cards[index];
      var link = card && card.querySelector('a[href*="/products/"]');
      var saved = {
        version: 1, section: sectionId, kind: root.dataset.shCollection,
        key: selectionKey(activeUrl), shown: cards.length,
        page: state.page, startPage: state.startPage || 1,
        x: window.scrollX, y: y, width: window.innerWidth,
        anchor: link ? new URL(link.href, location.href).pathname : '',
        index: index, offset: card ? card.getBoundingClientRect().top : 0
      };
      try { history.replaceState(Object.assign({}, history.state, { shBrowse: saved }), '', location.href); } catch (error) {}
    }
    function restorePosition(saved) {
      var token = ++restoreRevision;
      var stop = function () { restoreRevision++; restoring = false; };
      window.addEventListener('wheel', stop, { once: true, passive: true });
      window.addEventListener('touchstart', stop, { once: true, passive: true });
      window.addEventListener('keydown', stop, { once: true });
      return new Promise(function (resolve) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (token === restoreRevision && saved) {
              var y = saved.y;
              var cards = Array.from(grid.children);
              var anchor = cards.find(function (card) {
                var link = card.querySelector('a[href*="/products/"]');
                return link && new URL(link.href, location.href).pathname === saved.anchor;
              });
              if (anchor) y = window.scrollY + anchor.getBoundingClientRect().top - saved.offset;
              window.scrollTo({ left: saved.x || 0, top: Math.max(0, y), behavior: 'instant' });
            }
            window.removeEventListener('wheel', stop);
            window.removeEventListener('touchstart', stop);
            window.removeEventListener('keydown', stop);
            resolve();
          });
        });
      });
    }
    async function restoreBrowse(saved) {
      if (!saved) return apply(cleanUrl(location.href));
      restoring = true;
      if (selectionKey(activeUrl) === saved.key && grid.children.length === saved.shown && state.page === saved.page) {
        revision++;
        setBusy(false);
        await restorePosition(saved);
        restoring = false;
      } else {
        await apply(cleanUrl(location.href), { restore: saved });
      }
    }

    function cleanUrl(href) {
      var url = new URL(href, location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.delete('section_id');
      if (['created-descending', 'title-ascending', 'price-ascending'].indexOf(url.searchParams.get('sort_by')) === -1) url.searchParams.set('sort_by', 'created-descending');
      var requestedCategories = values(url, 'sh_category');
      if (requestedCategories.includes('bottoms') || requestedCategories.includes('other')) {
        url.searchParams.delete('sh_category');
        Array.from(new Set(requestedCategories.flatMap(function (value) {
          return value === 'bottoms' ? ['shorts', 'trousers'] : [value === 'other' ? 'accessories' : value];
        }))).forEach(function (value) { url.searchParams.append('sh_category', value); });
      }
      if (root.dataset.shCollection === 'mens_edit') {
        if (root.dataset.shSourceUrl) url.pathname = new URL(root.dataset.shSourceUrl, location.origin).pathname;
        url.searchParams.set('view', 'mens-edit');
        url.searchParams.delete('sh_fit');
      }
      if (comingSoonCategories.length) {
        var releasedCategories = values(url, 'sh_category').filter(function (value) { return !comingSoonCategories.includes(value); });
        url.searchParams.delete('sh_category');
        releasedCategories.forEach(function (value) { url.searchParams.append('sh_category', value); });
      }
      if (root.dataset.shCollection === 'all' || root.dataset.shCollection === 'mens_edit') {
        [sizeParam, pairParam].forEach(function (name) {
          var kept = values(url, name).filter(function (value) { return value.toUpperCase() !== 'XXS' && !omittedSizes.includes(value); });
          url.searchParams.delete(name);
          kept.forEach(function (value) { url.searchParams.append(name, value); });
        });
      }
      if (root.dataset.shCollection === 'all') {
        url.searchParams.delete('sh_fit');
        var requestedSizes = values(url, sizeParam).concat(values(url, pairParam));
        url.searchParams.delete(sizeParam);
        url.searchParams.delete(pairParam);
        Array.from(new Set(requestedSizes.filter(function (value) {
          return !omittedSizes.includes(value) && !(Number(value) > 0 && Number(value) < 20);
        }).map(function (value) {
          var choice = choices.find(function (choice) { return choice.name === sizeParam && (choice.value === value || choice.dataset.label === value); });
          return choice ? choice.value : value;
        }))).forEach(function (value) { url.searchParams.append(sizeParam, value); });
      }
      return url;
    }
    function values(url, name) {
      return url.searchParams.getAll(name).flatMap(function (value) { return value.split(','); }).filter(Boolean);
    }
    function categoryName(value, url) {
      if (!usesWomensSizes(url)) return value;
      if (value === 'tees' || value === 'camis' || value === 'longsleeves') return 'tops';
      if (value === 'boardies') return 'swimwear';
      return value;
    }
    function matchesCategoryValue(item, value, url) {
      var choice = choices.find(function (choice) { return choice.name === 'sh_category' && choice.value === value; });
      var fit = choice && choice.dataset.categoryFit;
      var category = choice && choice.dataset.categoryValue || value;
      if (fit && item.fit !== fit) return false;
      if (fit === 'womens' && categoryGroups[category]) return categoryGroups[category].includes(item.category);
      return categoryName(category, url) === categoryName(item.category, url);
    }
    function selectedCategories(url) { return values(url, 'sh_category').filter(function (value) { return categories.includes(value); }); }
    function selectedFits(url) {
      if (root.dataset.shCollection === 'mens_edit') return ['mens'];
      return [];
    }
    function choiceCaption(value) {
      var text = document.createElement('textarea');
      text.innerHTML = value;
      return text.value;
    }
    function usesWomensSizes(url) {
      return root.dataset.shCollection === 'ladies';
    }
    function pairIndex(choice) {
      if (choice.name !== sizeParam) return -1;
      var label = (choice.dataset.label || choice.value).trim().toUpperCase();
      return womensSizePairs.findIndex(function (pair) { return pair.includes(label); });
    }
    function selectedSizeLabels(url) {
      var selected = values(url, sizeParam);
      var labels = choices.filter(function (choice) { return choice.name === sizeParam && selected.includes(choice.value); }).map(function (choice) {
        var index = pairIndex(choice);
        return usesWomensSizes(url) && index >= 0 ? womensSizePairs[index].join('/') : choice.dataset.label;
      });
      values(url, pairParam).forEach(function (value) {
        var pair = womensSizePairs.find(function (pair) { return pair[0] === value; });
        if (pair) labels.push(usesWomensSizes(url) ? pair.join('/') : pair[0]);
      });
      return Array.from(new Set(labels));
    }
    function ensureWomensSizeChoices() {
      if (root.dataset.shCollection !== 'ladies') return;
      var section = form.querySelector('.sh-filter__size-section');
      if (!section || section.querySelector('[data-sh-womens-sizes]')) return;
      var group = document.createElement('div');
      group.className = 'sh-filter__size-group sh-filter__womens-sizes';
      group.setAttribute('data-sh-womens-sizes', '');
      group.hidden = true;
      var list = document.createElement('div');
      list.className = 'sh-filter__sizes';
      womensSizePairs.forEach(function (pair, index) {
        var label = document.createElement('label');
        label.className = 'sh-filter__size';
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.dataset.shSizePair = String(index);
        var caption = document.createElement('span');
        caption.textContent = pair.join('/');
        label.append(input, caption);
        list.appendChild(label);
      });
      group.appendChild(list);
      section.querySelector('summary').after(group);
    }
    function syncWomensSizeChoices(url) {
      var group = form.querySelector('[data-sh-womens-sizes]');
      if (!group) return;
      var enabled = usesWomensSizes(url);
      group.hidden = !enabled;
      group.querySelectorAll('[data-sh-size-pair]').forEach(function (input) {
        var index = Number(input.dataset.shSizePair);
        var members = choices.filter(function (choice) { return pairIndex(choice) === index; });
        var checked = pairedSizes.includes(womensSizePairs[index][0]) || members.some(function (choice) { return choice.checked; });
        var available = members.some(function (choice) { return !choice.closest('label').hasAttribute('data-sh-unavailable'); });
        input.checked = checked;
        input.disabled = !enabled || (!available && !checked);
        input.closest('label').toggleAttribute('data-sh-unavailable', !available);
        input.setAttribute('aria-label', womensSizePairs[index].join('/') + (available ? '' : ': ' + info.dataset.noMatches));
      });
      if (enabled) choices.forEach(function (choice) {
        if (pairIndex(choice) >= 0) choice.closest('label').hidden = true;
      });
    }
    function optionKey(url) {
      var key = cleanUrl(url.href);
      ['page', 'sh_category', 'sh_fit', sizeParam, pairParam, seasonParam, 'view'].forEach(function (name) { key.searchParams.delete(name); });
      key.searchParams.sort();
      return key.pathname + key.search;
    }
    async function getOptions(url) {
      var key = optionKey(url);
      if (optionCache.has(key)) return optionCache.get(key);
      var promise = (async function () {
        async function readPage(page, size) {
          var request = new URL(key, location.origin);
          request.searchParams.set('view', 'sh-filter-options');
          request.searchParams.set('page', String(page));
          if (size) request.searchParams.set(sizeParam, size);
          var response = await fetch(request.href, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Filter options request failed');
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          var data = doc.querySelector('[data-sh-filter-index]');
          if (!data) throw new Error('Filter options missing');
          return JSON.parse(data.textContent);
        }
        var scope = new URL(key, location.origin);
        // Product pages and grouped-size memberships do not depend on one another.
        // Start both together so opening filters does not wait through two request chains.
        var sizeRequest = (async function () {
          var first = await readPage(1);
          first.sizes.forEach(function (size) { sizeFamilyByValue.set(size.value, Number(size.label) >= 20 ? 'waist' : 'clothing'); });
          // Shopify can group several raw sizes under one filter value.
          // Resolve those memberships through the native filter, retaining the merchant's grouping.
          var groups = first.sizes.filter(function (size) { return size.count > 0 && size.value.indexOf('gid://') === 0; });
          var memberships = await Promise.all(groups.map(async function (size) {
            var part = await readPage(1, size.value);
            var ids = new Set(part.items.map(function (item) { return item.id; }));
            for (var page = 2; page <= part.pages; page++) {
              (await readPage(page, size.value)).items.forEach(function (item) { ids.add(item.id); });
            }
            return { value: size.value, ids: ids };
          }));
          return { sizes: first.sizes, memberships: memberships };
        })();
        var sources = await Promise.all([getAllCards(scope), sizeRequest]);
        var cards = sources[0];
        var memberships = sources[1].memberships;
        return {
          sizes: sources[1].sizes,
          // Count and display the same unique rendered products, including on the dedicated edits.
          items: cards.map(function (card) {
            var id = card.dataset.shProductId;
            var sizes = JSON.parse(card.dataset.shSizes || '[]').concat(memberships.filter(function (group) { return group.ids.has(Number(id)); }).map(function (group) { return group.value; }));
            return { id: id, card: card, category: card.dataset.category, fit: card.dataset.fit, sizes: sizes };
          })
        };
      })();
      if (optionCache.size >= 8) optionCache.delete(optionCache.keys().next().value);
      optionCache.set(key, promise);
      try { return await promise; } catch (error) { optionCache.delete(key); throw error; }
    }
    function matchesCategory(item, selected, url) { return !selected.length || selected.some(function (value) { return matchesCategoryValue(item, value, url); }); }
    function sizeFamily(value) { return sizeFamilyByValue.get(value) || (Number(value) >= 20 ? 'waist' : 'clothing'); }
    function matchesSize(item, selected, url, candidateCategory) {
      var pairs = values(url, pairParam);
      if (!selected.length && !pairs.length) return true;
      // Choosing accessories should include bags and other unsized pieces even
      // when a clothing size is still selected. Sized footwear keeps its size filter.
      if (item.category === 'accessories' && !item.sizes.length && ((candidateCategory && matchesCategoryValue(item, candidateCategory, url)) || selectedCategories(url).some(function (value) { return matchesCategoryValue(item, value, url); }))) return true;
      // Each size group narrows only products that use that sizing system.
      // Selecting XS must not hide waist-sized boardshorts before a waist is chosen.
      var selectedFamilies = new Set(selected.map(sizeFamily));
      if (pairs.length) selectedFamilies.add('clothing');
      if (item.sizes.some(function (size) { return !selectedFamilies.has(sizeFamily(size)); })) return true;
      var allowed = selected.slice();
      womensSizePairs.forEach(function (pair, index) {
        var members = choices.filter(function (choice) { return pairIndex(choice) === index; });
        var paired = pairs.includes(pair[0]);
        var womenPair = usesWomensSizes(url) && members.some(function (choice) { return selected.includes(choice.value); });
        if (!paired && !womenPair) return;
        members.forEach(function (choice) {
          var label = (choice.dataset.label || choice.value).trim().toUpperCase();
          // A women's clothing size must never become a men's footwear size.
          if (label === pair[0] || item.fit === 'womens') allowed.push(choice.value);
        });
      });
      return item.sizes.some(function (size) { return allowed.includes(size); });
    }
    function matchingItems(url, data) {
      return data.items.filter(function (item) {
        return matchesCategory(item, selectedCategories(url), url) && matchesSize(item, values(url, sizeParam), url) && matchesFit(item, selectedFits(url));
      });
    }
    function seasonCategoryOrder(url) {
      var selected = values(url, seasonParam);
      var orders = {
        Surf: ['boardies', 'tops', 'tees', 'shorts'],
        Snow: ['jackets', 'knits', 'fleeces', 'hoodies', 'sweatshirts', 'trousers', 'longsleeves', 'tops', 'tees', 'accessories']
      };
      if (root.dataset.shCollection === 'mens_edit') {
        orders = {
          Surf: ['boardies', 'tees', 'tops', 'shorts'],
          Snow: ['jackets', 'knits', 'fleeces', 'hoodies', 'sweatshirts', 'trousers', 'longsleeves', 'tops', 'tees', 'accessories']
        };
      }
      return (selected.length === 1 && orders[selected[0]]) || [];
    }
    function categoryDestination(url, value) {
      var destination = cleanUrl(url.href);
      names.forEach(function (name) { if (name !== 'sort_by') destination.searchParams.delete(name); });
      destination.searchParams.delete(pairParam);
      destination.searchParams.delete('page');
      destination.searchParams.delete('filter.v.price.gte');
      destination.searchParams.delete('filter.v.price.lte');
      var selected = selectedCategories(url);
      if (selected.length !== 1 || selected[0] !== value) destination.searchParams.set('sh_category', value);
      return destination;
    }
    function updateCarouselControls() {
      if (!categoryTrack) return;
      var controls = categoryCarousel.querySelector('[data-sh-carousel-controls]');
      var end = categoryTrack.scrollWidth - categoryTrack.clientWidth;
      controls.hidden = end < 2;
      categoryCarousel.querySelector('[data-sh-carousel-prev]').disabled = categoryTrack.scrollLeft < 2;
      categoryCarousel.querySelector('[data-sh-carousel-next]').disabled = categoryTrack.scrollLeft >= end - 2;
    }
    function syncCategoryCarousel(url, season) {
      if (!categoryCarousel) return;
      var priority = Array.from(new Set(seasonCategoryOrder(url).map(function (value) { return categoryName(value, url); })));
      var orderKey = priority.join(',');
      var resetScroll = carouselOrder !== orderKey;
      if (resetScroll) {
        carouselOrder = orderKey;
        categoryTiles.slice().sort(function (a, b) {
          var aRank = priority.indexOf(a.dataset.shCategoryTile);
          var bRank = priority.indexOf(b.dataset.shCategoryTile);
          return (aRank < 0 ? priority.length : aRank) - (bRank < 0 ? priority.length : bRank);
        }).forEach(function (tile) { categoryTrack.appendChild(tile); });
      }
      categoryTiles.forEach(function (tile) {
        var value = tile.dataset.shCategoryTile;
        var selected = selectedCategories(url).includes(value);
        var soon = tile.hasAttribute('data-sh-tile-soon');
        var representative = season && season.items.find(function (item) {
          return item.fit === tile.dataset.shTileFit && matchesCategoryValue(item, value, url);
        });
        tile.hidden = !matchesSeason({ category: value }, values(url, seasonParam)) || Boolean(season && !representative && !selected && !soon) || (!season && !tile.querySelector('img') && !soon);
        if (!soon) {
          var destination = categoryDestination(url, value);
          tile.href = destination.pathname + destination.search;
        }
        if (selected) tile.setAttribute('aria-current', 'true');
        else tile.removeAttribute('aria-current');
        if (representative && !tile.querySelector('img')) {
          var source = representative.card.querySelector('img');
          if (source) {
            var thumbnail = source.cloneNode(false);
            thumbnail.removeAttribute('id');
            thumbnail.alt = '';
            thumbnail.sizes = '(min-width: 750px) 114px, 78px';
            thumbnail.loading = 'lazy';
            tile.querySelector('.sh-category-carousel__image').replaceChildren(thumbnail);
          }
        }
      });
      categoryCarousel.hidden = categoryTiles.every(function (tile) { return tile.hidden; });
      requestAnimationFrame(function () {
        if (resetScroll) categoryTrack.scrollLeft = 0;
        updateCarouselControls();
      });
    }
    if (categoryCarousel) {
      categoryTrack.addEventListener('scroll', updateCarouselControls, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(updateCarouselControls).observe(categoryTrack);
      categoryCarousel.addEventListener('click', function (event) {
        var step = event.target.closest('[data-sh-carousel-prev], [data-sh-carousel-next]');
        if (step) {
          var direction = step.hasAttribute('data-sh-carousel-prev') ? -1 : 1;
          categoryTrack.scrollBy({ left: direction * categoryTrack.clientWidth * .85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          return;
        }
        var tile = event.target.closest('[data-sh-category-tile]');
        if (!tile || tile.hasAttribute('data-sh-tile-soon') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        apply(categoryDestination(activeUrl, tile.dataset.shCategoryTile), { history: true });
      });
    }
    function sortSeasonItems(items, url) {
      var priority = seasonCategoryOrder(url);
      if (!priority.length) return items;

      return items.map(function (item, index) {
        return { item: item, index: index };
      }).sort(function (a, b) {
        var aRank = priority.indexOf(a.item.category);
        var bRank = priority.indexOf(b.item.category);
        if (aRank < 0) aRank = priority.length;
        if (bRank < 0) bRank = priority.length;
        return aRank === bRank ? a.index - b.index : aRank - bRank;
      }).map(function (entry) {
        return entry.item;
      });
    }
    function matchesFit(item, selected) { return !selected.length || selected.includes(item.fit); }
    function matchesSeason(item, selected) {
      if (!selected.length) return true;
      var seasons = ['Surf', 'Snow'];
      if (['shorts', 'boardies', 'swimwear'].includes(item.category)) seasons = ['Surf'];
      else if (['jackets', 'trousers'].includes(item.category)) seasons = ['Snow'];
      return selected.some(function (season) { return seasons.includes(season); });
    }
    async function getOptionContext(url) {
      var scope = cleanUrl(url.href);
      Array.from(scope.searchParams.keys()).forEach(function (name) {
        if (name.indexOf('filter.v.price.') === 0) scope.searchParams.delete(name);
      });
      var data = await Promise.all([getOptions(url), getOptions(scope)]);
      var selected = values(url, seasonParam);
      function inSeason(part) {
        return { sizes: part.sizes, items: part.items.filter(function (item) { return matchesSeason(item, selected); }) };
      }
      return { matches: inSeason(data[0]), season: inSeason(data[1]) };
    }
    function ensureSizeChoices(data) {
      data.sizes.forEach(function (size) {
        if (root.dataset.shCollection === 'all' && !/^(XS|S|M|L|XL|XXL)$/.test(size.label) && !(Number(size.label) >= 20)) return;
        if (root.dataset.shCollection === 'mens_edit' && size.label === 'XXS') return;
        if (choices.some(function (choice) { return choice.name === sizeParam && choice.value === size.value; })) return;
        var numeric = Number(size.label);
        var group = numeric > 0 ? (numeric < 20 ? 'clothing' : 'waist') : 'letters';
        var container = form.querySelector('[data-sh-size-list]') || form.querySelector('[data-sh-size-group="' + group + '"] .sh-filter__sizes');
        if (!container) return;
        var label = document.createElement('label');
        label.className = 'sh-filter__size';
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.name = sizeParam;
        input.value = size.value;
        input.setAttribute('data-sh-choice', '');
        input.dataset.label = size.label;
        var caption = document.createElement('span');
        caption.textContent = size.label;
        label.append(input, caption);
        container.appendChild(label);
      });
      choices = Array.from(form.querySelectorAll('[data-sh-choice]'));
      fields = Array.from(form.querySelectorAll('input[name]'));
      names = Array.from(new Set(fields.map(function (field) { return field.name; })));
    }
    function ensureCategoryGroups() {
      if (!usesWomensSizes(activeUrl) || !categories.includes('tees')) return;
      var container = form.querySelector('[data-sh-categories] .sh-filter__categories');
      Object.keys(categoryGroups).forEach(function (value) {
        var original = choices.find(function (choice) { return choice.name === 'sh_category' && choice.value === value; });
        if (!original) return;
        var label = document.createElement('label');
        label.className = 'sh-filter__choice';
        label.hidden = true;
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.dataset.shCategoryGroup = value;
        var caption = document.createElement('span');
        caption.textContent = choiceCaption(original.dataset.womensLabel || original.dataset.label);
        label.append(input, caption);
        container.appendChild(label);
      });
    }
    function syncCategoryGroups(url, data) {
      var women = usesWomensSizes(url);
      var selected = selectedCategories(url);
      form.querySelectorAll('[data-sh-category-group]').forEach(function (input) {
        var value = input.dataset.shCategoryGroup;
        var members = categoryGroups[value];
        input.checked = selected.some(function (category) { return members.includes(category); });
        var available = data.items.some(function (item) {
          return members.includes(item.category) && matchesFit(item, selectedFits(url)) && matchesSize(item, values(url, sizeParam), url);
        });
        input.closest('label').hidden = !women;
        input.closest('label').toggleAttribute('data-sh-unavailable', !available);
        input.disabled = !women || (!available && !input.checked);
        input.setAttribute('aria-label', input.nextElementSibling.textContent + (available ? '' : ': ' + info.dataset.noMatches));
        if (women) choices.forEach(function (choice) {
          if (choice.name === 'sh_category' && members.includes(choice.value)) choice.closest('label').hidden = true;
        });
      });
    }
    function syncCategoryLayout(url) {
      var women = usesWomensSizes(url);
      info.classList.toggle('sh-filter--womens', women);
      var container = form.querySelector('[data-sh-categories] .sh-filter__categories');
      if (!container) return;
      var groups = Array.from(container.querySelectorAll('[data-sh-fit-group]'));
      var layouts = groups.length ? groups.map(function (group) {
        return { container: group.querySelector('.sh-filter__categories'), women: group.dataset.shFitGroup === 'womens' };
      }) : [{ container: container, women: women }];
      layouts.forEach(function (layout) {
        var list = layout.container;
        var priority = seasonCategoryOrder(url).map(function (value) {
          if (!layout.women) return value;
          return Object.keys(categoryGroups).find(function (group) { return categoryGroups[group].includes(value); }) || value;
        });
        var key = String(layout.women) + ':' + priority.join(',');
        if (list.dataset.categoryLayout === key) return;
        list.dataset.categoryLayout = key;
        var baseline = layout.women ? womensCategories : categories.filter(function (value) { return !value.includes(':'); });
        var order = Array.from(new Set(priority.concat(baseline)));
        var inputs = Array.from(list.querySelectorAll('[name="sh_category"]'));
        order.forEach(function (value) {
          var choice = inputs.find(function (item) { return (item.dataset.categoryValue || item.value) === value; });
          var grouped = layout.women && list.querySelector('[data-sh-category-group="' + value + '"]');
          if (grouped || choice) list.appendChild((grouped || choice).closest('label'));
        });
      });
    }
    function showOptions(url, data, season) {
      var selected = selectedCategories(url);
      var sizes = values(url, sizeParam);
      var fits = selectedFits(url);
      var womenOnly = usesWomensSizes(url);
      var menOnly = fits.length === 1 && fits[0] === 'mens';
      var body = form.querySelector('.sh-filter__body');
      var top = body.scrollTop;
      syncCategoryLayout(url);
      choices.forEach(function (choice) {
        var label = choice.closest('label');
        var isCategory = choice.name === 'sh_category';
        if (isCategory && choice.hasAttribute('data-sh-coming-soon')) {
          choice.checked = false;
          choice.disabled = true;
          label.hidden = values(url, seasonParam).includes('Surf') || (womenOnly && !womensCategories.includes(choice.value));
          label.removeAttribute('data-sh-unavailable');
          choice.setAttribute('aria-label', choice.dataset.label + ': ' + choice.dataset.shComingSoon);
          return;
        }
        var isFit = choice.name === 'sh_fit';
        var belongsToSeason = isFit || !choice.value || season.items.some(function (item) {
          return matchesFit(item, fits) && (isCategory ? matchesCategoryValue(item, choice.value, url) : item.sizes.includes(choice.value));
        });
        var available = isFit || !choice.value || data.items.some(function (item) {
          if (isFit) return item.fit === choice.value && matchesCategory(item, selected, url) && matchesSize(item, sizes, url);
          if (!matchesFit(item, fits)) return false;
          return isCategory ? matchesCategoryValue(item, choice.value, url) && matchesSize(item, sizes, url, choice.value) : item.sizes.includes(choice.value) && matchesCategory(item, selected, url);
        });
        var excluded = isCategory && ((menOnly && choice.value === 'swimwear') || !matchesSeason({ category: choice.dataset.categoryValue || choice.value }, values(url, seasonParam)));
        label.hidden = !choice.checked && (excluded || (isCategory && womenOnly ? !womensCategories.includes(choice.value) : !belongsToSeason));
        label.toggleAttribute('data-sh-unavailable', !available);
        choice.disabled = !available && !choice.checked;
        var caption = choiceCaption((womenOnly && choice.dataset.womensLabel) || (menOnly && choice.dataset.mensLabel) || choice.dataset.label || choice.value);
        if (isCategory) label.querySelector('span').textContent = caption;
        choice.setAttribute('aria-label', caption + (available ? '' : ': ' + info.dataset.noMatches));
      });
      syncCategoryGroups(url, data);
      syncWomensSizeChoices(url);
      form.querySelectorAll('[data-sh-size-group]').forEach(function (group) {
        group.hidden = !Array.from(group.querySelectorAll('label')).some(function (label) { return !label.hidden; });
      });
      var count = matchingItems(url, data).length;
      var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
      submit.textContent = (count === 1 ? info.dataset.resultsOne : info.dataset.resultsMany).replace('__count__', formatted);
      filterStatus.textContent = count ? '' : info.dataset.noResults;
      body.scrollTop = top;
    }
    async function refreshOptions() {
      var token = ++optionRevision;
      var url = draftUrl();
      optionsPending = true;
      submit.disabled = true;
      filterStatus.textContent = info.dataset.loading;
      dialog.setAttribute('aria-busy', 'true');
      try {
        var data = await getOptionContext(url);
        if (token !== optionRevision) return;
        ensureSizeChoices(data.season);
        syncForm(url);
        showOptions(url, data.matches, data.season);
        if (!busy && selectionKey(url) === selectionKey(activeUrl)) syncNavigation(url, matchingItems(url, data.matches).length);
        dialog.removeAttribute('aria-busy');
        dialog.classList.remove('sh-filter__dialog--loading');
        optionsPending = false;
        submit.disabled = busy;
      } catch (error) {
        if (token !== optionRevision) return;
        optionsPending = false;
        dialog.removeAttribute('aria-busy');
        dialog.classList.remove('sh-filter__dialog--loading');
        submit.disabled = busy;
        filterStatus.textContent = info.dataset.error;
      }
    }
    function nativeKey(url) {
      var key = cleanUrl(url.href);
      key.searchParams.delete('page');
      key.searchParams.delete('sh_category');
      key.searchParams.delete('sh_fit');
      key.searchParams.delete(sizeParam);
      key.searchParams.delete(pairParam);
      key.searchParams.delete(seasonParam);
      key.searchParams.sort();
      return key.pathname + key.search;
    }
    function snapshot(part) {
      var meta = part.querySelector('[data-sh-page-info]');
      if (!meta || !part.querySelector('[data-sh-grid]')) throw new Error('Missing collection section');
      return {
        cards: Array.from(part.querySelector('[data-sh-grid]').children).map(function (card) { return card.cloneNode(true); }),
        page: Number(meta.dataset.page),
        pages: Math.max(1, Number(meta.dataset.pages)),
        total: Number(meta.dataset.total)
      };
    }
    function pageCache(url) {
      var key = nativeKey(url);
      if (!cache.has(key)) {
        if (cache.size >= 4) cache.delete(cache.keys().next().value);
        cache.set(key, new Map());
      }
      return cache.get(key);
    }
    async function getPage(url, page) {
      var pages = pageCache(url);
      if (pages.has(page)) return pages.get(page);
      var request = new URL(nativeKey(url), location.origin);
      request.searchParams.set('page', String(page));
      request.searchParams.set('sections', sectionId);
      var promise = (async function () {
        var response = await fetch(request.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection request failed');
        var sections = await response.json();
        if (!sections[sectionId]) throw new Error('Collection section missing');
        var doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
        return snapshot(doc.querySelector('[data-sh-collection]'));
      })();
      pages.set(page, promise);
      try { return await promise; } catch (error) { pages.delete(page); throw error; }
    }
    function cardKey(card) {
      var link = card.querySelector('a[href*="/products/"]');
      return card.dataset.shProductId || (link && new URL(link.href, location.href).pathname);
    }
    async function getAllCards(url) {
      var first = await getPage(url, 1);
      var pages = [first];
      for (var page = 2; page <= first.pages; page += 3) {
        var batch = [];
        for (var next = page; next < page + 3 && next <= first.pages; next++) batch.push(getPage(url, next));
        pages.push.apply(pages, await Promise.all(batch));
      }
      var seen = new Set();
      return pages.flatMap(function (part) { return part.cards; }).filter(function (card) {
        var key = cardKey(card);
        if (!key) return true;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }
    async function getMatching(url, data) {
      var first = await getPage(url, 1);
      var filtered = selectedCategories(url).length || selectedFits(url).length === 1 || values(url, sizeParam).length || values(url, pairParam).length || values(url, seasonParam).length;
      return { first: first, matches: filtered ? sortSeasonItems(matchingItems(url, data), url).map(function (item) { return item.card; }) : null };
    }
    function syncForm(url) {
      if (sortSelect) sortSelect.value = url.searchParams.get('sort_by') || 'created-descending';
      pairedSizes = values(url, pairParam);
      names.forEach(function (name) {
        var selected = values(url, name);
        fields.filter(function (field) { return field.name === name; }).forEach(function (field) {
          if (field.type === 'checkbox') {
            var index = pairIndex(field);
            var paired = index >= 0 && pairedSizes.includes(womensSizePairs[index][0]) && (field.dataset.label || field.value).trim().toUpperCase() === womensSizePairs[index][0];
            field.checked = field.value ? selected.includes(field.value) || paired : !selected.length;
            if (field.checked) field.disabled = false;
          }
          else if (name === 'sort_by') field.value = url.searchParams.get('sort_by') || 'created-descending';
          else field.value = url.searchParams.get(name) || '';
        });
      });
      updateSizeSummary();
      updateFitSummaries();
    }
    function updateFitSummaries() {
      form.querySelectorAll('[data-sh-fit-disclosure]').forEach(function (group) {
        var count = group.querySelectorAll('[name="sh_category"]:checked').length;
        var label = group.querySelector('[data-sh-fit-selected]');
        label.textContent = count ? '(' + count + ')' : '';
        label.hidden = count === 0;
      });
    }
    function updateSizeSummary() {
      var label = root.querySelector('[data-sh-size-summary]');
      if (!label) return;
      var selected = selectedSizeLabels(draftUrl());
      label.textContent = selected.length > 3 ? selected.length + ' ' + info.dataset.selected : selected.join(', ') || info.dataset.allSizes;
    }
    function draftUrl() {
      var url = cleanUrl(activeUrl.href);
      names.forEach(function (name) { url.searchParams.delete(name); });
      new FormData(form).forEach(function (value, name) {
        var choice = choices.find(function (item) { return item.name === name && item.value === value; });
        var index = choice ? pairIndex(choice) : -1;
        if (index >= 0 && pairedSizes.includes(womensSizePairs[index][0])) return;
        if (String(value).trim()) url.searchParams.append(name, String(value).trim());
      });
      url.searchParams.delete(pairParam);
      pairedSizes.forEach(function (value) { url.searchParams.append(pairParam, value); });
      url.searchParams.delete('page');
      return cleanUrl(url.href);
    }
    function resetDraft() {
      pairedSizes = [];
      choices.forEach(function (choice) { choice.checked = choice.value === ''; });
      fields.forEach(function (field) { if (field.type === 'number') field.value = ''; });
      filterStatus.textContent = '';
      updateSizeSummary();
      updateFitSummaries();
      refreshOptions();
    }
    form.addEventListener('change', function (event) {
      var choice = event.target;
      if (choice.matches('[data-sh-category-group]')) {
        var members = categoryGroups[choice.dataset.shCategoryGroup];
        choices.filter(function (item) { return item.name === 'sh_category' && members.includes(item.value); }).forEach(function (item) {
          item.checked = choice.checked;
          if (choice.checked) item.disabled = false;
        });
        refreshOptions();
      } else if (choice.matches('[data-sh-size-pair]')) {
        var index = Number(choice.dataset.shSizePair);
        var pair = womensSizePairs[index];
        pairedSizes = pairedSizes.filter(function (value) { return value !== pair[0]; });
        if (choice.checked) pairedSizes.push(pair[0]);
        choices.filter(function (item) { return pairIndex(item) === index; }).forEach(function (item) {
          item.checked = false;
        });
        updateSizeSummary();
        refreshOptions();
      } else if (choice.matches('[data-sh-choice]')) {
        var index = pairIndex(choice);
        if (index >= 0 && !choice.checked) pairedSizes = pairedSizes.filter(function (value) { return value !== womensSizePairs[index][0]; });
        var group = choices.filter(function (item) { return item.name === choice.name; });
        if (!choice.value) group.forEach(function (item) { item.checked = item === choice; });
        else {
          var all = group.find(function (item) { return !item.value; });
          if (all) all.checked = !group.some(function (item) { return item.value && item.checked; });
        }
        updateSizeSummary();
        refreshOptions();
      } else if (choice.type === 'number') refreshOptions();
    });
    root.querySelector('[data-sh-reset]').addEventListener('click', resetDraft);
    const categoryField = root.querySelector('[data-sh-categories]');
    if (categoryField) categoryField.hidden = false;

    function lockScroll() {
      if (lockedY !== null) return;
      lockedY = window.scrollY;
      previousBodyTop = document.body.style.getPropertyValue('--sh-scroll-top');
      previousScrollbar = document.body.style.getPropertyValue('--sh-scrollbar');
      document.body.style.setProperty('--sh-scrollbar', Math.max(0, window.innerWidth - document.documentElement.clientWidth) + 'px');
      document.body.style.setProperty('--sh-scroll-top', -lockedY + 'px');
      document.body.classList.add('sh-filter-open');
    }
    function unlockScroll() {
      if (lockedY === null) return;
      var y = lockedY;
      lockedY = null;
      document.body.classList.remove('sh-filter-open');
      document.body.style.setProperty('--sh-scroll-top', previousBodyTop);
      document.body.style.setProperty('--sh-scrollbar', previousScrollbar);
      window.scrollTo({ top: y, behavior: 'instant' });
    }
    function closeFilters() {
      if (dialog.open) dialog.close();
      refine.open = false;
      unlockScroll();
      summary.focus({ preventScroll: true });
    }
    function selectionKey(url) {
      var key = cleanUrl(url.href);
      key.searchParams.delete('page');
      return key.pathname + JSON.stringify(Array.from(key.searchParams).sort());
    }
    async function saveAndClose() {
      if (closePending) return;
      var url = draftUrl();
      optionRevision++;
      optionsPending = false;
      if (!busy && selectionKey(url) === selectionKey(activeUrl)) {
        submit.disabled = false;
        closeFilters();
        return;
      }
      closePending = true;
      try {
        await apply(url, { history: true, close: true });
      } finally {
        closePending = false;
      }
    }
    refine.addEventListener('toggle', function () {
      if (refine.open && !dialog.open) {
        syncForm(activeUrl);
        form.querySelectorAll('[data-sh-fit-disclosure]').forEach(function (group) { group.open = false; });
        filterStatus.textContent = '';
        lockScroll();
        dialog.showModal();
        form.querySelector('.sh-filter__body').scrollTop = 0;
        dialog.querySelector('h2').focus({ preventScroll: true });
        dialog.classList.add('sh-filter__dialog--loading');
        refreshOptions();
      } else if (!refine.open && dialog.open) saveAndClose();
    });
    dialog.addEventListener('close', function () {
      refine.open = false;
      unlockScroll();
      summary.focus({ preventScroll: true });
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      saveAndClose();
    });
    root.querySelector('[data-sh-close]').addEventListener('click', saveAndClose);
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) saveAndClose();
    });
    function seasonLinks() {
      return root.dataset.shCollection === 'all' ? Array.from(document.querySelectorAll('#syd-season-band [data-season-value]')) : Array.from(root.querySelectorAll('[data-sh-season]'));
    }
    function seasonDestination(href, season) {
      var destination = cleanUrl(href);
      var current = values(destination, seasonParam);
      var changing = season ? current.length !== 1 || current[0] !== season : current.length > 0;
      if (changing) {
        ['sh_category', 'sh_fit', sizeParam, pairParam, 'filter.v.price.gte', 'filter.v.price.lte'].forEach(function (name) {
          destination.searchParams.delete(name);
        });
      }
      destination.searchParams.delete('page');
      destination.searchParams.delete(seasonParam);
      if (season) destination.searchParams.set(seasonParam, season);
      return destination;
    }
    function syncNavigation(url, total) {
      var selected = values(url, seasonParam);
      var labels = [];
      seasonLinks().forEach(function (link) {
        var season = link.hasAttribute('data-sh-season') ? link.dataset.shSeason : link.dataset.seasonValue;
        var on = season ? selected.includes(season) : !selected.length;
        if (on) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        var badge = link.querySelector('[data-sh-selected]');
        if (badge) badge.hidden = !on;
        if (on && season) labels.push(link.dataset.seasonLabel || season);
        var destination = seasonDestination(url.href, season);
        link.href = destination.pathname + destination.search;
      });
      var count = new Intl.NumberFormat(document.documentElement.lang || 'en').format(total) + ' ' + (total === 1 ? info.dataset.one : info.dataset.many);
      var countNode = root.querySelector('[data-sh-count]') || root.querySelector('[data-ladies-count]') || document.querySelector('#syd-season-band [data-archive-count]');
      if (countNode) countNode.textContent = count;
      if (root.dataset.shCollection === 'all') {
        var band = document.getElementById('syd-season-band');
        if (band) band.querySelector('[data-season-current]').textContent = labels.length ? labels.join(' + ') : band.dataset.allLabel;
      } else {
        var currentSeason = root.querySelector('[data-sh-season-current], [data-ladies-season-current]');
        if (currentSeason) currentSeason.textContent = labels.length ? labels.join(' + ') : root.dataset.allSeasons;
      }
      var selectedCount = new Set(selectedCategories(url).map(function (value) { return categoryName(value, url); })).size + selectedSizeLabels(url).length + (root.dataset.shCollection === 'mens_edit' ? 0 : selectedFits(url).length);
      if (url.searchParams.has('filter.v.price.gte') || url.searchParams.has('filter.v.price.lte')) selectedCount++;
      root.querySelector('[data-sh-active]').textContent = selectedCount ? '(' + selectedCount + ')' : '';
      status.textContent = count;
    }
    function appendCards(cards, replace) {
      var fragment = document.createDocumentFragment();
      var seen = new Set(replace ? [] : Array.from(grid.children).map(cardKey));
      cards.forEach(function (card) {
        var key = cardKey(card);
        if (key && seen.has(key)) return;
        if (key) seen.add(key);
        var copy = card.cloneNode(true);
        // Page fragments can include another copy of the first card's CSS.
        // The initial copy already lives outside this replaceable grid.
        copy.querySelectorAll('style, link[rel="stylesheet"]').forEach(function (asset) { asset.remove(); });
        copy.hidden = false;
        copy.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        copy.querySelectorAll('.media[data-syd-gallery]').forEach(function (media) {
          media.removeAttribute('data-syd-observed');
          media.removeAttribute('data-syd-built');
          media.removeAttribute('data-syd-ready');
          media.querySelectorAll('.syd-swipe, .syd-dots').forEach(function (item) { item.remove(); });
        });
        fragment.appendChild(copy);
      });
      if (replace) grid.replaceChildren(fragment);
      else grid.appendChild(fragment);
    }
    function refreshCardGalleries() {
      root.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionId } }));
    }
    function updateMore() {
      var more = state.matches ? state.shown < state.matches.length : state.page < state.pages;
      pagination.hidden = !more;
      pagination.replaceChildren();
      if (!more) return;
      var link = document.createElement('a');
      link.className = root.dataset.shCollection === 'ladies' ? 'sh-ladies__button' : 'sh-filter__apply';
      link.textContent = info.dataset.more;
      var destination = cleanUrl(activeUrl.href);
      destination.searchParams.set('page', String(state.page + 1));
      link.href = destination.pathname + destination.search;
      link.setAttribute('data-sh-more', '');
      pagination.appendChild(link);
    }
    function setBusy(value) {
      busy = value;
      submit.disabled = value || optionsPending;
      if (sortSelect) sortSelect.disabled = value;
      root.setAttribute('aria-busy', String(value));
      if (value) {
        if (dialog.open) filterStatus.textContent = info.dataset.loading;
        else status.textContent = info.dataset.loading;
      } else filterStatus.textContent = '';
    }
    async function apply(url, options) {
      options = options || {};
      if (options.history) saveBrowse();
      restoreRevision++;
      restoring = Boolean(options.restore);
      var token = ++revision;
      var y = window.scrollY;
      setBusy(true);
      try {
        var optionData = await getOptionContext(url);
        if (token !== revision) return;
        ensureSizeChoices(optionData.season);
        var result = await getMatching(url, optionData.matches);
        if (token !== revision) return;
        var cards = result.matches || result.first.cards;
        var total = result.matches ? result.matches.length : optionData.matches.items.length;
        var shown = options.restore ? Math.max(pageSize, options.restore.shown) : pageSize;
        var lastPage = 1;
        var startPage = 1;
        if (options.restore && !result.matches) {
          startPage = Math.min(result.first.pages, Math.max(1, Number(options.restore.startPage) || 1));
          lastPage = Math.min(result.first.pages, Math.max(startPage, Number(options.restore.page) || 1));
          var restoredPages = [];
          for (var page = startPage; page <= lastPage; page += 3) {
            var batch = [];
            for (var next = page; next < page + 3 && next <= lastPage; next++) batch.push(getPage(url, next));
            restoredPages.push.apply(restoredPages, await Promise.all(batch));
            if (token !== revision) return;
          }
          cards = restoredPages.flatMap(function (part) { return part.cards; });
          shown = cards.length;
        }
        appendCards(cards.slice(0, shown), true);
        root.classList.remove('sh-collection--pending');
        root.classList.remove('sh-collection--failed');
        root.classList.remove('sh-collection--count-pending');
        state = { matches: result.matches, shown: Math.min(shown, cards.length), page: lastPage, startPage: startPage, pages: result.first.pages };
        activeUrl = cleanUrl(url.href);
        activeUrl.searchParams.delete('page');
        empty.hidden = total > 0;
        updateMore();
        ensureSizeChoices(optionData.season);
        syncForm(activeUrl);
        showOptions(activeUrl, optionData.matches, optionData.season);
        syncCategoryCarousel(activeUrl, optionData.season);
        syncNavigation(activeUrl, total);
        if (options.history) history.pushState({ shCollection: true }, '', activeUrl.pathname + activeUrl.search);
        refreshCardGalleries();
        setBusy(false);
        if (options.restore) await restorePosition(options.restore);
        else if (options.close) closeFilters();
        else if (lockedY === null) window.scrollTo({ top: y, behavior: 'instant' });
        if (token !== revision) return;
        restoring = false;
        saveBrowse();
      } catch (error) {
        if (token !== revision) return;
        restoring = false;
        setBusy(false);
        if (root.classList.contains('sh-collection--pending')) root.classList.add('sh-collection--failed');
        (dialog.open ? filterStatus : status).textContent = info.dataset.error;
      }
    }
    if (sortSelect) sortSelect.addEventListener('change', async function () {
      var destination = cleanUrl(activeUrl.href);
      destination.searchParams.set('sort_by', sortSelect.value);
      destination.searchParams.delete('page');
      await apply(destination, { history: true });
      syncForm(activeUrl);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      saveAndClose();
    });
    seasonLinks().forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        var season = link.hasAttribute('data-sh-season') ? link.dataset.shSeason : link.dataset.seasonValue;
        var current = values(activeUrl, seasonParam);
        if (!busy && (season ? current.length === 1 && current[0] === season : !current.length)) return;
        apply(seasonDestination(activeUrl.href, season), { history: true });
      });
    });
    root.querySelector('[data-sh-empty-reset]').addEventListener('click', function () {
      var url = cleanUrl(activeUrl.href);
      names.forEach(function (name) { if (name !== 'sort_by') url.searchParams.delete(name); });
      url.searchParams.delete(pairParam);
      apply(url, { history: true });
    });
    pagination.addEventListener('click', async function (event) {
      var link = event.target.closest('[data-sh-more]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (busy || !state) return;
      var token = ++revision;
      setBusy(true);
      try {
        var cards;
        var nextPage = state.page;
        if (state.matches) {
          cards = state.matches.slice(state.shown, state.shown + pageSize);
        } else {
          var part = await getPage(activeUrl, state.page + 1);
          cards = part.cards;
          nextPage = part.page;
        }
        if (token !== revision) return;

        // Capture at insertion time so scrolling during the request is respected.
        var x = window.scrollX;
        var y = window.scrollY;
        var firstNewIndex = grid.children.length;
        var moveFocus = pagination.contains(document.activeElement);
        document.documentElement.classList.add('sh-appending-products');
        try {
          appendCards(cards, false);
          state.shown += cards.length;
          state.page = nextPage;
          updateMore();
          refreshCardGalleries();
          setBusy(false);
          status.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(grid.children.length) + ' ' + (grid.children.length === 1 ? info.dataset.one : info.dataset.many);
          // Continue keyboard browsing at the new rows without following the button.
          var firstNewCard = grid.children[firstNewIndex];
          if (moveFocus && firstNewCard) {
            firstNewCard.setAttribute('tabindex', '-1');
            firstNewCard.focus({ preventScroll: true });
          }
          window.scrollTo({ left: x, top: y, behavior: 'instant' });
          saveBrowse();
        } finally {
          // Keep native anchoring off until the inserted rows have been laid out.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              document.documentElement.classList.remove('sh-appending-products');
            });
          });
        }
      } catch (error) {
        if (token !== revision) return;
        setBusy(false);
        status.textContent = info.dataset.error;
      }
    });
    window.addEventListener('popstate', function () { restoreBrowse(savedBrowse()); });
    window.addEventListener('scroll', function () {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(saveBrowse, 200);
    }, { passive: true });
    grid.addEventListener('click', saveBrowse, true);
    window.addEventListener('pagehide', function () { saveBrowse(); unlockScroll(); });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) restoreBrowse(savedBrowse());
    });
    var initial = snapshot(root);
    var originalUrl = new URL(location.href);
    if (info.dataset.sort === activeUrl.searchParams.get('sort_by') && !values(originalUrl, sizeParam).length && !values(originalUrl, seasonParam).length) pageCache(activeUrl).set(initial.page, Promise.resolve(initial));
    if (values(originalUrl, seasonParam).length) root.classList.add('sh-collection--pending');
    if (values(originalUrl, 'sh_category').some(function (value) { return comingSoonCategories.includes(value) || (value === 'bottoms' && comingSoonCategories.includes('trousers')); }) || ((root.dataset.shCollection === 'all' || root.dataset.shCollection === 'mens_edit') && (originalUrl.searchParams.has('sh_fit') || originalUrl.searchParams.has(pairParam) || values(originalUrl, sizeParam).join() !== values(activeUrl, sizeParam).join()))) {
      history.replaceState(history.state, '', activeUrl.pathname + activeUrl.search);
      root.classList.add('sh-collection--pending');
    }
    ensureWomensSizeChoices();
    ensureCategoryGroups();
    syncForm(activeUrl);
    syncCategoryCarousel(activeUrl);
    if (!root.classList.contains('sh-collection--pending') && root.dataset.shCollection !== 'mens_edit') syncNavigation(activeUrl, initial.total);
    state = { matches: null, shown: initial.cards.length, page: initial.page, startPage: initial.page, pages: initial.pages };
    var saved = savedBrowse();
    if (saved) {
      if (root.classList.contains('sh-collection--pending') || selectedCategories(activeUrl).length || values(activeUrl, sizeParam).length || values(activeUrl, pairParam).length || info.dataset.sort !== activeUrl.searchParams.get('sort_by')) apply(activeUrl, { restore: saved });
      else { updateMore(); restoreBrowse(saved); }
    } else if (root.classList.contains('sh-collection--pending') || selectedCategories(activeUrl).length || values(activeUrl, sizeParam).length || values(activeUrl, pairParam).length || info.dataset.sort !== activeUrl.searchParams.get('sort_by')) apply(activeUrl);
    else { if (initial.page === 1) updateMore(); saveBrowse(); }
    // Prepare filters while customers browse the first rows, and reconcile the initial
    // count with the unique cards before showing it. The visible grid remains usable.
    if (!busy) {
      var initialKey = selectionKey(activeUrl);
      getOptionContext(activeUrl).then(function (data) {
        if (!busy && selectionKey(activeUrl) === initialKey) {
          var matches = matchingItems(activeUrl, data.matches);
          // The Men's first rows are already filtered in Liquid. Keep their loaded
          // images in place and add any remaining first-page cards in the background.
          if (root.dataset.shCollection === 'mens_edit' && initial.page === 1 && state.page === 1 && !state.matches) {
            var cards = matches.map(function (item) { return item.card; });
            var shown = Math.min(pageSize, cards.length);
            if (shown > state.shown) {
              appendCards(cards.slice(state.shown, shown), false);
              refreshCardGalleries();
            }
            state.matches = cards;
            state.shown = Math.max(state.shown, shown);
            updateMore();
          }
          syncNavigation(activeUrl, matches.length);
          syncCategoryCarousel(activeUrl, data.season);
          root.classList.remove('sh-collection--count-pending');
        }
      }).catch(function () { root.classList.remove('sh-collection--count-pending'); });
    }
  }
  function initAll() { document.querySelectorAll('[data-sh-collection]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

